import { NavList } from "../shared";

const AbbvieProAppList = () => {
    const appList = [
        { url: "/abbvie-pro/forms", name: "Forms" },
        {
            url: "/abbvie-pro/persona",
            name: "Personalization Configuration",
        },
    ];

    return <NavList backUrl="/" title="Abbvie Pro Configurations" navList={appList} />;
};

export default AbbvieProAppList;
